import { AlertSchema, AlertStatusEnum } from '@src/entities/Alert/includes/schemas';
import { z } from 'zod';

export type * from '../api/requests/mutations/SaveAlert/includes/types';
export * from '../api/requests/queries/ListAlerts/includes/defaults';
export type * from '../api/requests/queries/ListAlerts/includes/types';
export * from './defaults';

export type AlertStatus = z.infer<typeof AlertStatusEnum>;
export type AlertEntity = z.infer<typeof AlertSchema>;
export type AlertActions = 'edit';
